const selectionProcessStepsData = {
  title: '¿Cómo ser parte de Fingo?',
  subtitle: 'Revisa los pasos a los que te enfrentarás al ser parte del proceso de selección de Fingo',
  steps: [
    {
      id: 0,
      stepTitle: 'Espera la evaluación de tu CV',
    },
    {
      id: 1,
      stepTitle: 'Entrevista técnica',
    },
    {
      id: 2,
      stepTitle: 'Entrevista con RRHH',
    },
    {
      id: 3,
      stepTitle: 'Entrevista con Líder de Área/ Gerente',
    },
    {
      id: 4,
      stepTitle: '¡Comienza una nueva aventura!',
    },
  ],
};

export default selectionProcessStepsData;
